import {app} from "../../config/constants";

export const deleteStatistics = async (key) => {
	return new Promise( ( resolve, reject ) => {
		if ( undefined === key ) {
			resolve();
			return null;
		}

		new Promise( ( resolve, reject ) => {
			app.database().ref('/cams/statistics/views').orderByChild('key').equalTo(key).once( 'value', async (viewsSnap) => {
				viewsSnap.forEach( async (view ) => {
					await view.set(null);
				});

				resolve();
			});
		}).then( () => {
			return app.database().ref('/cams/statistics/detailed/clicks').child( key ).remove();
		}).then( () => {
			return app.database().ref('/cams/statistics/simple/clicks').child( key ).remove();
		}).then( () => {
			return app.database().ref('/cams/statistics/detailed/views').child( key ).remove();
		}).then( () => {
			return app.database().ref('/cams/statistics/simple/views').child( key ).remove();
		}).then( () => {
			resolve();
		});
	});
};


// WEBPACK FOOTER //
// ./src/api/statistics/index.js